export const FETCH_VIVO_GAMES_TOKEN = 'FETCH_VIVO_GAMES_TOKEN';
export const SUCCESS_FETCH_VIVO_GAMES_TOKEN = 'SUCCESS_FETCH_VIVO_GAMES_TOKEN';
export const FAILURE_FETCH_VIVO_GAMES_TOKEN = 'FAILURE_FETCH_VIVO_GAMES_TOKEN';

export const FETCH_TVBET_GAMES_TOKEN = 'FETCH_TVBET_GAMES_TOKEN';
export const SUCCESS_FETCH_TVBET_GAMES_TOKEN = 'SUCCESS_FETCH_TVBET_GAMES_TOKEN';
export const FAILURE_FETCH_TVBET_GAMES_TOKEN = 'FAILURE_FETCH_TVBET_GAMES_TOKEN';

export const FETCH_TVBET_DEMO_GAMES = 'FETCH_TVBET_DEMO_GAMES'

export const FETCH_TVBET_ROULLETTE_DEMO = 'FETCH_TVBET_ROULLETTE_DEMO'

export const FETCH_FASTSPORT_GAMES_TOKEN = 'FETCH_FASTSPORT_GAMES_TOKEN';
export const SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN = 'SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN';
export const FAILURE_FETCH_FASTSPORT_GAMES_TOKEN = 'FAILURE_FETCH_TVBET_GAMES_TOKEN';

export const FETCH_TVBET_ROULLETTE_TOKEN = 'FETCH_TVBET_ROULLETTE_TOKEN';
export const SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN = 'SUCCESS_FETCH_TVBET_ROULLETTE_TOKEN';
export const FAILURE_FETCH_TVBET_ROULLETTE_TOKEN = 'FAILURE_FETCH_TVBET_ROULLETTE_TOKEN';

export const FETCH_BETSOLUTIONS_GAMES_TOKEN = 'FETCH_BETSOLUTIONS_GAMES_TOKEN';
export const SUCCESS_FETCH_BETSOLUTIONS_GAMES_TOKEN = 'SUCCESS_FETCH_BETSOLUTIONS_GAMES_TOKEN';
export const FAILURE_FETCH_BETSOLUTIONS_GAMES_TOKEN = 'FAILURE_FETCH_BETSOLUTIONS_GAMES_TOKEN';

export const FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = 'FETCH_VIRTUAL_SPORTS_GAMES_TOKEN';
export const SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = 'SUCCESS_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN';
export const FAILURE_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN = 'FAILURE_FETCH_VIRTUAL_SPORTS_GAMES_TOKEN';

export const FETCH_XPRESS_GAMES = 'FETCH_XPRESS_GAMES';
export const SUCCESS_FETCH_XPRESS_GAMES = 'SUCCESS_FETCH_XPRESS_GAMES';
export const FAILURE_FETCH_XPRESS_GAMES = 'FAILURE_FETCH_XPRESS_GAMES';

export const FETCH_XPRESS_TOKEN = 'FETCH_XPRESS_TOKEN';
export const SUCCESS_FETCH_XPRESS_TOKEN = 'SUCCESS_FETCH_XPRESS_TOKEN';
export const FAILURE_FETCH_XPRESS_TOKEN = 'FAILURE_FETCH_XPRESS_TOKEN';

export const CLEAR_TV_BET_ERROR = "CLEAR_TV_BET_ERROR";

export const FETCH_PROVIDER_XPRESS_GAMES = 'FETCH_PROVIDER_XPRESS_GAMES'
export const SUCCESS_FETCH_PROVIDER_XPRESS_GAMES =  'SUCCESS_FETCH_PROVIDER_XPRESS_GAMES'
export const FAILURE_FETCH_PROVIDER_XPRESS_GAMES = 'FAILURE_FETCH_PROVIDER_XPRESS_GAMES'

export const FETCH_TYPE_XPRESS_GAMES = 'FETCH_TYPE_XPRESS_GAMES'
export const SUCCESS_FETCH_TYPE_XPRESS_GAMES = 'SUCCESS_FETCH_TYPE_XPRESS_GAMES'
export const FAILURE_FETCH_TYPE_XPRESS_GAMES = 'FAILURE_FETCH_TYPE_XPRESS_GAMES'

export const FETCH_PINNED_XPRESS_GAMES = 'FETCH_PINNED_XPRESS_GAMES'
export const SUCCESS_FETCH_PINNED_XPRESS_GAMES = 'SUCCESS_FETCH_PINNED_XPRESS_GAMES'
export const FAILURE_FETCH_PINNED_XPRESS_GAMES = 'FAILURE_FETCH_PINNED_XPRESS_GAMES'

export const UPDATE_XPRESS_PINNED_GAMES = "UPDATE_XPRESS_PINNED_GAMES";


// WEBPACK FOOTER //
// ./js/actions/games/index.js